import lotteryResults from "./lotteryResults";
import utility from './utility'

const syndicate = {
    init: function () {
        var syndicateContainer = document.querySelector("#syndicates-container");
        if (syndicateContainer) {
            new this.startupActions(syndicateContainer);
        }
        this.updateSyndicateShares();
    },

    startupActions: class {
        constructor(container) {
            const msg = container.dataset.notifymessage;
            const url = container.dataset.notifymessageplaynowurl;

            const loadingShimmer = `
                <div class="shimmer-wrapper">
                    <div class="d-flex">
                        <div class="shimmer-circle shimmer-circle-md shimmer-animate"></div>
                        <div class="d-flex flex-column" style="width:80%">
                            <div class="shimmer-line shimmer-line-br shimmer-line-80 shimmer-animate mt-10 ml-10"></div>
                            <div class="shimmer-line shimmer-line-br shimmer-line-80 shimmer-animate mt-10 ml-10"></div>
                        </div>
                    </div>
                    <div class="shimmer-line shimmer-line-br shimmer-line-full shimmer-animate"></div>
                    <div class="shimmer-line shimmer-line-br shimmer-line-full shimmer-animate"></div>
                    <div class="shimmer-line shimmer-line-br shimmer-line-full shimmer-animate"></div>
                    <div class="shimmer-line shimmer-line-br shimmer-line-full shimmer-animate"></div>
                </div>
            `;

            if (msg) {
                var button = null;
                if (url) {
                    button = {
                        url: url,
                        text: "Play now"
                    }
                }
                utility.showNotificationPopup({
                    content: msg,
                    button: button
                });
            }

            [...document.querySelectorAll(".expand-no-scroll")].map(btn => {
                btn.addEventListener("click", function () {
                    const syndicateId = this.dataset.syndicateid;
                    const syndicateDetails = document.getElementById(syndicateId);
                    if (syndicateDetails.dataset.hasOwnProperty("detailsLoaded")) {
                        return;
                    } else {
                        syndicateDetails.innerHTML = loadingShimmer;
                    }
                    const ajaxOptions = {
                        url: `/api/web/lottery/syndicate-details?syndicateId=${syndicateId}`,
                        method: "GET",
                        success: function (e) {
                            syndicateDetails.dataset.detailsLoaded = "1";
                            syndicateDetails.innerHTML = e.target.responseText;
                            [...syndicateDetails.querySelectorAll(".results-expand")].map(exp => {
                                lotteryResults.resultExpandItemClick(exp);
                            });
                        }
                    };
                    utility.ajaxRequest(ajaxOptions);
                });
            });

            [...container.querySelectorAll("form.syndicates-form button")].map(el => {
                el.onclick = (event) => {
                    const button = event.currentTarget;
                    const form = event.currentTarget.closest("form");
                    utility.disableButton(button);
                    utility.ajaxRequest({
                        url: "/api/web/lottery/syndicate-play",
                        method: "POST",
                        data: utility.getFormData(form),
                        responseType: "text",
                        success: function (e) {
                            const result = JSON.parse(e.target.responseText);
                            if (result.success) {
                                window.location.href = "/checkout";
                            }
                            else {
                                utility.enableButton(button);
                                const errorMessage = result.error ? result.error : "An unknown error occurred.";
                                utility.showNotificationPopup({
                                    title: "Error",
                                    content: errorMessage
                                });
                            }
                        },
                        error: function () {
                            utility.enableButton(button);
                            utility.showNotificationPopup({
                                title: "Error",
                                content: "An unknown error has occurred"
                            });
                        }
                    });
                }
            });
        }
    },

    updateSyndicateShares: () => {
        [...document.querySelectorAll('.alter-syndicate-share')].map(toggle => {
            toggle.addEventListener('click', debounce((e) => {
                const syndicateItem = e.target
                const itemId = syndicateItem.dataset.itemid
                const shares = syndicateItem.dataset.shares
                const shareNumber = syndicateItem.parentElement.querySelector("h3").innerHTML = `${shares}<span>Shares</span>`
                const ajaxOptions = {
                    url: "/api/web/checkout/set-syndicate-shares",
                    method: "POST",
                    data: "itemId=" + itemId + "&shares=" + shares,
                    success: function (e) {
                        window.location.reload(true);
                    },
                };
                utility.ajaxRequest(ajaxOptions);
                return true;

            }, 500));

            function debounce(callback, wait) {
                let timeout;
                return (...args) => {
                    const context = this;
                    clearTimeout(timeout);
                    timeout = setTimeout(() => callback.apply(context, args), wait);
                };
            }
        });
    },

}

export default syndicate;



// WEBPACK FOOTER //
// ./assets/src/js/classes/syndicate.js